import {
  MAFIA_SESSION_ID,
  MAFIA_SESSION_TOKEN,
  MAFIA_UBID_MAIN
} from 'constants/apis';

import { SESSION_RECEIVED } from './types';

import { call, put, takeEvery } from 'redux-saga/effects';
import { sessionExpiration, setAndStoreCookie } from 'actions/session';

export function* withSession(args) {
  const result = yield call(...args);
  const { session } = result;
  yield put({ type: SESSION_RECEIVED, session });
  return result;
}

export function* watchSessionReceived() {
  yield takeEvery(SESSION_RECEIVED, action => setSession(action));
}

export function* setSession(action) {
  const { session } = action;

  if (session.get(MAFIA_SESSION_TOKEN)) {
    return;
  }

  const sessionId = session.get(MAFIA_SESSION_ID);
  const ubidMain = session.get(MAFIA_UBID_MAIN);
  const expiration = sessionExpiration();

  if (sessionId && ubidMain) {
    yield put(setAndStoreCookie('session-id', sessionId, expiration));
    yield put(setAndStoreCookie('ubid-main', ubidMain, expiration));
  }
}

export default [watchSessionReceived];
